import { render, staticRenderFns } from "./FriendsList.vue?vue&type=template&id=a0079490&scoped=true"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"
import style0 from "./FriendsList.vue?vue&type=style&index=0&id=a0079490&lang=scss&scoped=true"
import style1 from "./FriendsList.vue?vue&type=style&index=1&id=a0079490&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0079490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0079490')) {
      api.createRecord('a0079490', component.options)
    } else {
      api.reload('a0079490', component.options)
    }
    module.hot.accept("./FriendsList.vue?vue&type=template&id=a0079490&scoped=true", function () {
      api.rerender('a0079490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenge-friends/components/FriendsList.vue"
export default component.exports